import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
    analyticsNativeUpgradeNotificationViewed,
    analyticsNativeUpgradeNotificationClose,
    analyticsNativeUpgradeNotificationClickCta,
} from '@perpay-web/fintech/actions/analytics/nativeUpgradeNotification';
import NativeUpgradeNotification from '@perpay-web/fintech/components/composite/NativeUpgradeNotification/NativeUpgradeNotification';
import { useNativeUpgradeNotificationModalContext } from '@perpay-web/fintech/hooks/useNativeUpgradeNotificationModalContext';

const NativeUpgradeNotificationContainer = () => {
    const dispatch = useDispatch();

    const { setIsAnimatedModalOpen, animatedModalClassName } =
        useNativeUpgradeNotificationModalContext();

    const onMount = useCallback(
        () => dispatch(analyticsNativeUpgradeNotificationViewed()),
        [dispatch],
    );
    const onClickCta = useCallback(() => {
        dispatch(analyticsNativeUpgradeNotificationClickCta());
        setIsAnimatedModalOpen(false);
    }, [dispatch, setIsAnimatedModalOpen]);
    const onClose = useCallback(() => {
        dispatch(analyticsNativeUpgradeNotificationClose());
        setIsAnimatedModalOpen(false);
    }, [dispatch, setIsAnimatedModalOpen]);

    return (
        <NativeUpgradeNotification
            className={animatedModalClassName}
            onMount={onMount}
            onClickCta={onClickCta}
            onClose={onClose}
        />
    );
};

export default NativeUpgradeNotificationContainer;
